// eslint-disable-next-line no-shadow
export enum VehicleIcon {
    Compact = 1,
    MidSize = 2,
    FullSize = 3,
    HeavyDuty = 4,
    Van = 5
}
